import Component from "../abstracts/Component";

export default class UpperCaseComponent extends Component {

  constructor() {
    super();
  }

  bindEvents() {
    document.querySelectorAll('.js-forceUppercase').forEach(function (uppercaseElement) {
      uppercaseElement.addEventListener('input', function () {
        uppercaseElement.value = this.value.toUpperCase();
      });
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
